var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('loading-page')],1):_c('chart',{attrs:{"consultations":_vm.consultations,"medical_visits":_vm.medical_visits}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }